import { FunctionComponent, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { ConfigContext } from '../../../context';
import { IconLabel } from '../../../shared';

import classes from './Description.module.scss';

export const Description: FunctionComponent = () => {
  const { t } = useTranslation();

  const { href } = { ...useContext(ConfigContext).config.elements.leaderBoard };

  return (
    <div className={classes['description']}>
      <IconLabel iconId={'info'} color={'#FFC600'} singleColor nonClickable />
      <div>{t('leaderBoard.schlager-description')}</div>
      {href && (
        <a
          className={classes['description__link']}
          href={href}
          target={'_blank'}
          rel={'noreferrer'}
        >
          {t('leaderBoard.find-out-more')}
        </a>
      )}
    </div>
  );
};
